import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { GIVING_BASKET_SUB_TYPE } from 'utils/constants';
import { BasketsAutocompleteProps } from 'types/autocomplete';

import { AppDispatch } from 'redux/store';
import { fetchGivingBasket } from 'redux/slices/baskets/givingBasketSilce';
import { debounce } from 'utils/helpers';
import Autocomplete from 'components/Common/Autocomplete';
import { Basket } from 'types/common';

const BasketsAutocomplete = ({ defaultValue, companyId, ...props }: BasketsAutocompleteProps) => {
    const dispatch = useDispatch<AppDispatch>();
    const [loading, setLoading] = useState(false);
    const [baskets, setBaskets] = useState<Basket[]>([]);
    const [searchText, setSearchText] = useState('');

    const fetchBaskets = useCallback(
        async (searchText?: string) => {
            try {
                setLoading(true);
                const { payload }: any = await dispatch(
                    fetchGivingBasket({
                        status: 'ACTIVE',
                        subType: GIVING_BASKET_SUB_TYPE,
                        name: searchText,
                        companyId,
                        headers: {
                            pageNumber: 0,
                            pageSize: 50,
                        },
                    })
                );
                setLoading(false);
                const { events = [] } = payload?.response || {};
                setBaskets(events);
            } catch (e) {}
        },
        [dispatch, companyId]
    );

    useEffect(() => {
        fetchBaskets(searchText);
    }, [fetchBaskets, searchText]);

    return (
        <Autocomplete
            loading={loading}
            options={baskets}
            label="Baskets"
            placeholder="Please type to search..."
            defaultValue={defaultValue || null}
            getOptionLabel={(opt) => opt?.name}
            noOptionsText={searchText && loading ? 'Loading...' : searchText ? 'No options' : 'Please type to search...'}
            onInputChange={debounce((_: any, searchText: any) => setSearchText(searchText), 700)}
            {...props}
        />
    );
};

export default BasketsAutocomplete;
